<!--
 * @Author: DQL
 * @Date: 2022-04-28 11:18:16
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 15:26:18
 * @Description: 检测会议管理
 -->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        {{ dlTypeStr }}
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
        <k-button
          btn-text="新增"
          :auth-type="true"
          type="success"
          icon="kestrel-icon ki-plus"
          @click="openNavTab({ name: 'addHygl'})"
        />
        <!-- <k-button
          btn-text="导出"
:auth-type="false"
          type="primary"
          icon="kestrel-icon ki-export"
          plain
          :disabled="page.rows.length<1"
          @click="handleExport()"
        >
          导出
        </k-button>-->
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          :rules="filterParamsRules"
          label-position="right"
          label-width="90px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="会议标题"
                prop="hybt"
              >
                <el-input
                  v-model.trim="filterParams.hybt"
                  class="c-form__input"
                  placeholder="请输入会议标题"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="请输入项目名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="kTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #xmmc="scope"
            >
              <el-link
                type="primary"
                @click="openNavTab({ name: 'viewXfjc', params: { xmId: scope.row.xmId } })"
              >
                {{ scope.row.xmmc }}
              </el-link>
            </template>
            <template #xmztMc="scope">
              <span>
                {{ scope.row.xmztMc || '/' }}
              </span>
            </template>
            <template
              #bgbh="scope"
            >
              <el-link
                type="primary"
                @click="(e)=>$utils.previewPdf(e,scope.row.bgUrl)"
              >
                {{ scope.row.bgbh }}
              </el-link>
            </template>
            <template #zhpdjl="scope">
              <span
                class="c-form__read"
              >
                {{ scope.row.zhpdjl =='Y'?'合格': scope.row.zhpdjl =='N'?'不合格':'/' }}
              </span>
            </template>
            <el-table-column
              prop="enabled"
              label="操作"
              width="100"
              align="center"
              fixed="right"
            >
              <template
                slot-scope="scope"
              >
                <template>
                  <k-button
                    btn-text="编辑"
                    :auth-type="true"
                    type="primary"
                    plain
                    @click="openNavTab({name: 'editHygl',params: { xmId: scope.row.xmId } })"
                  />
                </template>
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->
    <!-- 其他说明 -->

    <!-- 申请修改 -->
    <sqxg-dialog
      v-if="showDialogName === 'sqxg'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />
  </div>
</template>
<script>
import { hyglService } from './hygl.service';
import SqxgDialog from '../xmgl/details/SqxgDialog.vue';

export default {
  name: 'JcbgIndex',
  components: {
    SqxgDialog
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        bglx: [],
        bgType: null, // 状态
        cjsjQZ: [], // 创建时间起止
        cjsjq: null, // 创建时间起
        cjsjz: null, // 创建时间止
        xmmc: null // 项目名称
      },
      /* 查询条件 end */

      /* 表单校验规则 Start */
      filterParamsRules: {
        cjsjQZ: [this.$HMValidator.dateRange('开始时间')]
      },
      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */
      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'hybt', slotName: 'hybt', label: '会议标题', align: 'left', minWidth: '200', type: 'text' },
        { key: 'xmmc', label: '项目名称', align: 'left', minWidth: '150', type: 'text' },
        { key: 'hysj', slotName: 'hysj', label: '会议时间', align: 'center', minWidth: '130', type: 'text' },
        { key: 'tjsj', slotName: 'tjsj', label: '添加时间', align: 'left', minWidth: '150', type: 'text' }
      ],
      /* 表格列配置End */

      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 end */
    };
  },
  computed: {
    dlType () {
      return this.$route.name;
    },
    dlTypeStr () {
      return this.$route.meta.navtabTitle;
    },
    xmType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_XMLX) {
        return enums.IFF_XMLX;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      if (this.$refs.filterParams) {
        this.$refs.filterParams.validate(valid => {
          if (valid) {
            this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
            [this.trueFilterParams.cjsjq, this.trueFilterParams.cjsjz] = this.trueFilterParams.cjsjQZ;
            this.search();
          }
        });
      } else {
        this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
        [this.trueFilterParams.cjsjq, this.trueFilterParams.cjsjz] = this.trueFilterParams.cjsjQZ;
        this.search();
      }
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      hyglService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);

          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });

      /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    }
    /**
     * @description: 新增用户
     * @param {*}
     * @return {*}
     */
  },
  created () {
    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>
